import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  CheckBenefitEligibility,
  CheckBenefitStatus,
  getBanks,
  InitiateBenefitsApplication,
} from "../../redux/selfService/selfServiceSlice";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import PageName from "../../components/PageName";
import SuccessModal from "../../components/SuccessModal";
import Card from "../../components/Base/Card";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  BenefitApplicationType,
  BenefitLumpSumType,
  BenefitModeOfExit,
} from "../../constants";
import { getStates } from "../../redux/utils/utilsSlice";
import BaseDatePicker from "../../components/Base/BaseDatePicker";
// Define a state variable to store the selected benefit type

//const { user } = useAppSelector((state) => state?.auth);
const InitiateBenefit = () => {
  const [selectedBenefitType, setSelectedBenefitType] = useState<number | null>(
    -1
  );
  const [responseErrors, setResponseErrors] = useState<string[]>([]);

  const dispatch = useAppDispatch();
  const [isEligibleCheck, setIsEligibleCheck] = useState(true);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  //  const { isLoading } = useAppSelector((state) => state?.selfService);
  const { user, isLoading } = useAppSelector((state) => ({
    user: state.auth.user,
    isLoading: state.selfService.isLoading,
  }));
  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Please select benefit type"),
    lumpSumType: Yup.string().required("Please select"),
    modeOfExit: Yup.string().required("Please select"),
    dateOfDisengagement: Yup.date().required("Please select"),
  });

  const defaultValues = {
    type: "",
    lumpSumType: "",
    modeOfExit: "",
    dateOfDisengagement: new Date(),
  };

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  // Add an event handler for the benefit type dropdown
  const handleBenefitTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedType = parseInt(event.target.value, 10);
    setSelectedBenefitType(selectedType);

    // Check eligibility here
    if (selectedType !== -1) {
      dispatch(CheckBenefitEligibility({ type: selectedType })).then((res) => {
        console.log(res);
        if (
          res.type === "selfService/CheckBenefitEligibility/fulfilled" &&
          res.payload !== undefined
        ) {
          setIsEligibleCheck(true);
        }
        setResponseErrors(res.payload || []);
        // Log the response
        console.log(responseErrors);
        console.log("Response:", res);
      });
    }
  };
  useEffect(() => {
    setIsEligibleCheck(true);
    // Remove the existing code for checking eligibility on page load
  }, []);

  const onSubmit = (values: any) => {
    const formattedValues = {
      ...values,
      dateOfDisengagement: new Date(values.dateOfDisengagement).toISOString(),
    };
    dispatch(InitiateBenefitsApplication(formattedValues)).then((res) => {
      console.log("submitted res", res);
      if (
        res?.type === "selfService/InitiateBenefitsApplication/fulfilled" &&
        res.payload &&
        res.payload.statusCode === "00"
      ) {
        setShowSuccessModal(true);
      }
    });
  };
  return (
    <div className="statement-page">
      <PageName pageName={"Inititate Benefit Application"} />

      <div className="rsa_form_component">
        <Card className="transaction-card">
          <div className="h1 text-grayscaleBody border-b pb-4">
            Initiate Benefits
          </div>
          {/* <div className="flex justify-end mt-10">
                        <a href={RouteNames.INITIATE_BENEFIT} className="btn btn-primary">
                            Initiate Benefit
                        </a>
                    </div> */}
          {isLoading && !isEligibleCheck ? (
            <div className="load">
              <div className="load-placeholder">
                <div className="load-placeholder-text text-xl text-center mb-4">
                  Checking Eligibility
                </div>
                <div className="load-placeholder-spinner">
                  <LoadingSpinner size="lg" />
                </div>
              </div>
            </div>
          ) : isEligibleCheck ? (
            <div>
              <SuccessModal
                showModal={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                note={"Benefit application have been innitiated."}
              />
              {/* <div className="mx-4">
                                Initiate Benefit
                            </div> */}
              <div className="w-full">
                <Card className="mb-8 ">
                  <div className="section-card">
                    <div className="pt-12 whitespace-pre mr-6">
                      Benefit Information
                    </div>
                    <div className="w-full">
                     
                      <div className="form__row">
                        <div className="form__group">
                          <label htmlFor="type" className="form__label">
                            Type: <Required />
                          </label>
                          <select
                            id="type"
                            className="form__select"
                            {...register("type")}
                            onChange={handleBenefitTypeChange} // Add the event handler
                          >
                            <option value="">Select benefit type</option>
                            {BenefitApplicationType.map((benefitType) => (
                              <option
                                value={benefitType.value}
                                key={benefitType.value}
                              >
                                {benefitType.title}
                              </option>
                            ))}
                          </select>
                          {errors.type && (
                            <ErrorViewer
                              message={errors.type.message as string}
                            />
                          )}
                        </div>

                        <div className="form__group">
                          <label htmlFor="lumpSumType" className="form__label">
                            Lump Sum Type: <Required />
                          </label>
                          <select
                            id="lumpSumType"
                            className="form__select"
                            {...register("lumpSumType")}
                          >
                            <option value="">Select Lump Sum Type</option>
                            {BenefitLumpSumType.map((lumpSumType) => (
                              <option
                                value={lumpSumType.value}
                                key={lumpSumType.value}
                              >
                                {lumpSumType.title}
                              </option>
                            ))}
                          </select>
                          {errors.lumpSumType && (
                            <ErrorViewer
                              message={errors.lumpSumType.message as string}
                            />
                          )}
                        </div>
                      </div>

                      <div className="form__row">
                        <div>
                          {/* Display badges based on responseObject */}
                          {/* Display badges based on responseObject */}
                          {responseErrors && responseErrors.length > 0 && (
                            <div className="badges">
                              {responseErrors.map((error, index) => (
                                <div className="warning-badge" key={index}>
                                  {error}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form__row">
                        <div className="form__group">
                          <label htmlFor="modeOfExit" className="form__label">
                            Mode of Exit: <Required />
                          </label>
                          <select
                            id="modeOfExit"
                            className="form__select"
                            {...register("modeOfExit")}
                          >
                            <option value="">Select Mode of Exit</option>
                            {BenefitModeOfExit.map((modeOfExit) => (
                              <option
                                value={modeOfExit.value}
                                key={modeOfExit.value}
                              >
                                {modeOfExit.title}
                              </option>
                            ))}
                          </select>
                          {errors.modeOfExit && (
                            <ErrorViewer
                              message={errors.modeOfExit.message as string}
                            />
                          )}
                        </div>
                        <div className="form__group">
                          <label
                            htmlFor="dateOfDisengagement"
                            className="form__label"
                          >
                            Date of Disengagement: <Required />
                          </label>
                          <BaseDatePicker
                            onChange={(date: Date) => {
                              setValue("dateOfDisengagement", date);
                            }}
                          />
                          {errors.dateOfDisengagement && (
                            <ErrorViewer
                              message={
                                errors.dateOfDisengagement.message as string
                              }
                            />
                          )}
                        </div>
                      </div>
                      {/*
                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label htmlFor="bankID" className="form__label">
                                                        Bank <Required />
                                                    </label>
                                                    <select id="bankID" className="form__select" {...register("bankID")} >
                                                        <option value="">Select Bank</option>
                                                        {
                                                            Object.keys(allBanks.banks).length > 0 && Object.keys(allBanks.banks).map((bankId: any) =>
                                                                <option value={bankId} key={bankId}>{allBanks.banks[bankId]}</option>
                                                            )
                                                        }
                                                    </select>
                                                    {errors.bankID && (
                                                        <ErrorViewer message={errors.bankID.message as string}/>
                                                    )}
                                                </div>
                                                <div className="form__group">
                                                    <label htmlFor="bankBranch" className="form__label">
                                                        Bank Branch <Required />
                                                    </label>
                                                    <select id="bankBranch" className="form__select"
                                                        onChange={(e)=>{
                                                            setValue("bankBranch", allStates[e.target.value])
                                                            setValue("bankBranchStateCode", e.target.value)
                                                        }}
                                                    >
                                                        <option value="">Select Bank Branch</option>
                                                        {allStates && Object.keys(allStates).map((state) => (
                                                            <option value={state} key={state}>{allStates[state]}</option>
                                                        ))}
                                                    </select>
                                                    {errors.bankBranch && (
                                                        <ErrorViewer message={errors.bankBranch.message as string}/>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form__row">
                                                <div className="form__group">
                                                    <label htmlFor="accountNumber" className="form__label">
                                                        Account Number <Required />
                                                    </label>
                                                    <input placeholder="Account number" type="number" id="accountNumber"
                                                           className="form__input" {...register("accountNumber")} />
                                                    {errors.accountNumber && (
                                                        <ErrorViewer message={errors.accountNumber.message as string}/>
                                                    )}
                                                </div>
                                                <div className="form__group">
                                                    <label htmlFor="requestedAmount" className="form__label">
                                                        Amount <Required />
                                                    </label>
                                                    <input placeholder="Amount" type="number" id="requestedAmount"
                                                           className="form__input" {...register("requestedAmount")} />
                                                    {errors.requestedAmount && (
                                                        <ErrorViewer message={errors.requestedAmount.message as string}/>
                                                    )}
                                                </div>
                                            </div>
                                    */}
                    </div>
                  </div>
                </Card>
                <div className="flex justify-end text-primary mb-40">
                  {/* <button
                                        className="btn btn-primary font-semibold mr-4"
                                        onClick={handleSubmit(onSubmit)}
                                        disabled={isLoading || isEligibleCheck}
                                    >
                                        {
                                            isLoading ? <LoadingSpinner /> : "Initiate Benefit"
                                        }
                                    </button> */}

                  <button
                    className={`btn btn-primary font-semibold mr-4${
                      isLoading ? " disabled" : ""
                    }`}
                    onClick={handleSubmit(onSubmit)}
                    // disabled={isLoading || isEligibleCheck}
                    style={
                      !isLoading 
                        ? {}
                        : { opacity: 0.5, cursor: "not-allowed" }
                    }
                    title={
                      isEligibleCheck ? "" : ""
                    }
                  >
                    {isLoading ? <LoadingSpinner /> : "Initiate Benefit"}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="load">
              <div className="load-placeholder">
                <div className="load-placeholder-text text-xl text-center mb-4">
                  You cannot currently initiate benefit.
                </div>
                <div className="load-placeholder-spinner">
                  {/*<LoadingSpinner size="lg" />*/}
                </div>
              </div>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
};
export default InitiateBenefit;
